import { render, staticRenderFns } from "./anamnese.vue?vue&type=template&id=5c5900de&"
import script from "./anamnese.js?vue&type=script&lang=js&"
export * from "./anamnese.js?vue&type=script&lang=js&"
import style0 from "./anamnese.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports